// extracted by mini-css-extract-plugin
export default {"headerBox":"Login_headerBox__4z3j3","login_container":"Login_login_container__sRkTV","socialContent":"Login_socialContent__txnkF","forgotBox":"Login_forgotBox__zlBfb"};